import { phoneWordFontSize } from "./VocaMatchingCard";
import "./VocaCards.css";

// [원본 복원] 전개발자 구조(고정 높이 + 앞뒤 absolute) 그대로. 고정 높이라 iOS에서도 행 붕괴가 없던 검증된 구조.
// 겉모양은 VocaCards.css(ECHO 톤, 2026-10-27). 여기 남은 인라인 값은 크기와 뒤집기뿐이다.
// iOS 접두사는 레이아웃과 상관없이 뒷면 비침만 막는다.
const VocaStudyCard = ({ word, handleFlip }) => {
  const m = Math.min(window.innerWidth, window.screen.width) <= 768;
  const faceStyle = {
    position: "absolute",
    height: "100%",
    width: "100%",
    backfaceVisibility: "hidden",
    WebkitBackfaceVisibility: "hidden",
    padding: m ? "4px" : "12px",
  };
  return (
    <div
      style={{
        transform: word.isOpened ? "rotateY(180deg)" : "rotateY(0deg)",
        WebkitTransform: word.isOpened ? "rotateY(180deg)" : "rotateY(0deg)",
        transition: "transform 0.5s",
        // 데스크톱은 컨테이너 기준으로 5장이 정확히 들어가게. vw 로 하면
        // 컨테이너(약 1200px)보다 넓어져 좌우가 잘렸다 (5장×16vw=80vw).
        width: m ? "15.5vw" : "calc(20% - 10px)",
        minWidth: m ? "56px" : 0,
        height: m ? "84px" : "25vh",
        transformStyle: "preserve-3d",
        WebkitTransformStyle: "preserve-3d",
        position: "relative",
      }}
    >
      <div
        className="voca-tile voca-tile--word"
        lang="en"
        style={{
          ...faceStyle,
          overflow: "hidden",
          fontSize: m ? phoneWordFontSize(word.eng) : undefined,
          hyphens: "auto",
          WebkitHyphens: "auto",
          wordBreak: "break-word", // 긴 단어가 있을 경우 강제 줄바꿈
          overflowWrap: "break-word",
          whiteSpace: "normal",
        }}
        onClick={() => handleFlip(word)}
      >
        {word.eng}
      </div>
      <div
        className="voca-tile voca-tile--back"
        style={{
          ...faceStyle,
          transform: "rotateY(180deg)",
          WebkitTransform: "rotateY(180deg)",
        }}
        onClick={() => handleFlip(word)}
      >
        <div
          style={{
            // 뜻이 길면 글자를 짓누르지 않고 **카드 안에서 스크롤한다.** 짧으면 가운데, 길면 위에서부터.
            // maxHeight 를 안 걸면 부모 flex 가운데 정렬이 넘친 글을 위아래로 밀어 잘라 버린다.
            maxHeight: "100%",
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "normal",
          }}
        >
          {word.kor}
        </div>
      </div>
    </div>
  );
};

export default VocaStudyCard;
